import * as React from 'react';
import { Tooltip } from 'src/component/Global/Tooltip';
import Constants from './Constants';
import System from "src/helper/system";

const {
  countryTariff: {
    BrazilTariff,
    NonBrazilTariff
  }
} = Constants

class ReusableDiv {

  static checkoutStepTitle = (title) => (
    <div className="checkout-titles d-flex justify-content-between">
      <h2>{title}</h2>
    </div>
  );

  static QuoteHeader = (tab = "") => (
    <div className="container">
      <div className="pcn-page-head header-container d-flex align-items-center justify-content-between">
        <div className="page-title font-oswald font-light font-30">Quotes</div>
        {(tab === "QuoteHeaderDetail" || tab === "QuoteAddress") &&
          <a href="https://www.avnet.com/opasdata/help/quoting-help.pdf" target={"_blank"} data-placement="bottom"
             data-toggle="tooltip"
             data-html="true"><i className="fa fa-info-circle me-2 text-black" aria-hidden="true"/>
            <span className="text-blue">Information</span></a>}
      </div>
      <div className="pcn-line-divider"/>
    </div>
  );

  static EstimatedShippingTooltip = () => (
    <div>
      The exact freight amount will be calculated at the time shipment is processed and will appear on your shipment
      notifications.
    </div>
  );

  static PopupTitle = (title) => (
    <div className="modal-header border-0">
      <h3 className="modal-title m-auto" id="exampleModalLabel">{title}</h3>
    </div>
  );

  static dataSheetTooltip = () => (
    <Tooltip position={'right center'}
             opener={() => (
               <span className="lifecycle low-risk lifecycle-not-available"
                     aria-hidden="true"
                     data-toggle="tooltip"
                     data-placement="bottom"
                     data-html="true"
                     data-title="Datasheet not available.">
                    <span>--</span>
                </span>
             )}
             content={() => (
               <>
                 Datasheet not available.
               </>
             )}
    />
  );

  static newsLetterAd = () => (
    <>
      <div className='m-b-20' id="espotImg">
      </div>
      <div className='newsletter m-b-20'>
        <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
        <p className='m-b-15 text-black'>Subscribe for online delivery</p>
        <a className='bs5 btn btn-primary w135'>Sign up now</a>
      </div>
    </>
  );
  static shippDetail = (params) => (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        {<div className="shipping-additional-info step-complete-hide info-text">
          {(params.countryTariff == NonBrazilTariff) && <>
            <p>These products will be shipped directly from America. You will be responsible for all Duties and Taxes.
              Freight rates are given per shipment on weights up to 10 pounds (4 kg). The exact freight amount will be
              calculated at the time the shipment is processed and will appear on your shipment notifications.</p>

            <p className='mt-3 pt-1'><strong>Tariff</strong></p>
            <p>
              Avnet may assess a Tariff Recovery Fee. The final charge will be included on the invoice. Even if no
              tariff recovery charge is quoted or indicated, Avnet reserves the right to impose this charge whenever a
              tariff is incurred, or as additional country of origin information is known. Avnet is making every
              commercial effort to mitigate tariffs through our FTZ. However, materials may be subject to an IEEPA
              related tariff recovery fee due to industry & government dynamics beyond Avnet’s control.
              <br/>
              For more information, visit <a target="_blank" href={System.getTariffInfoUrl()}>Avnet Tariff
              Information</a>.<br/>
              A current list of these products and applicable tariffs is located at <a href={System.getUSTRUrl()}
                                                                                       target="_blank">{System.getUSTRUrl()}</a>.
            </p>
          </>}
          {params.countryTariff == BrazilTariff && <><p>These products will be shipped directly from America. You will
            be responsible for all Duties and Taxes. Freight rates are given per shipment on weights up to 10 pounds (4
            kg). The exact freight amount will be calculated at the time the shipment is processed and will appear on
            your shipment notifications.</p>
            <p className='mt-3 pt-1'><strong>Brazil Taxes</strong></p>
            <p>All Brazil orders are subject to any and all applicable import duties, federal and state taxes.<br/>(II,
              IPI, PIS, COFINS, ICMS). Taxes vary depending on shipping selections.</p></>}
          <br/>
          {params.internationalNewArk &&
            <p>You have entered an international shipping address which will incur additional shipping and handling
              charges.</p>}
        </div>}
      </div>
    </>
  );

}

export default ReusableDiv;